import { render, staticRenderFns } from "./select-position.vue?vue&type=template&id=6509e039&"
import script from "./select-position.vue?vue&type=script&lang=js&"
export * from "./select-position.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports